import {
  PosIntegrations,
  SupportedBrands,
  SupportedIntegrationsWithBrands,
} from '@sdk/integrations/types';

import ToastIconSvg from '../../../../assets/svg/integrations/toast-icon.svg';
import SquareIconSvg from '../../../../assets/svg/integrations/square-icon.svg';
import ShopifyIconSvg from '../../../../assets/svg/integrations/shopify-icon.svg';
import HarbortouchIconSvg from '../../../../assets/svg/integrations/harbortouch-icon.svg';
import PositouchIconSvg from '../../../../assets/svg/integrations/positouch-icon.svg';
import RestaurantManagerIconSvg from '../../../../assets/svg/integrations/restaurant_manager-icon.svg';
import Shift4 from '../../../../assets/svg/integrations/shift4-icon.svg';
import DefaultIconSvg from '../../../../assets/svg/Icons/32/announcement-red.svg';

const getIntegrationIcon = (integrationType: SupportedIntegrationsWithBrands) => {
  switch (integrationType) {
    case PosIntegrations.toast:
      return ToastIconSvg;

    case PosIntegrations.square:
      return SquareIconSvg;

    case PosIntegrations.shopify:
      return ShopifyIconSvg;

    case PosIntegrations.shift4:
      return Shift4;

    case SupportedBrands.harbortouch:
      return HarbortouchIconSvg;

    case SupportedBrands.positouch:
      return PositouchIconSvg;

    case SupportedBrands.restaurantManager:
      return RestaurantManagerIconSvg;

    default:
      return DefaultIconSvg;
  }
};

export default getIntegrationIcon;
